import {call, put, takeLatest, select} from 'redux-saga/effects'
import {initialize} from 'redux-form'
import i18n from '../../i18n'
import {downloadDocument} from '../../util/util'
import actionTypes from '../../constants/actions/importarContactosExcel/importarContactosExcel'
import {submitImportarContactosExcelSuccess} from '../../actions/importarContactosExcel/importarContactosExcel'
import {openModal, closeModal, openSimpleModal, openMensajeAlerta} from '../../actions/common'
import { yesNoModal } from '../modal/yesNoModal'
import getImportarContactosExcel from '../../services/importarContactosExcel/getImportarContactosExcel'
import getDescargarPlantillaExcelContactosExcel from '../../services/importarContactosExcel/getDescargarPlantillaExcelContactosExcel'

export function * submitImportarContactosExcel ({value}) {
  try {
    let auth = yield select(state => state.auth)
    const listCargaIndex = yield call(getImportarContactosExcel, value, auth.token)    
    yield put(submitImportarContactosExcelSuccess(listCargaIndex))
  } catch (error) {
    console.log(error)
  } finally {
    /*yield put(commonActions.hideLoader())*/
  }
}
export function * watchSubmitImportarContactosExcel () {
  yield takeLatest(actionTypes.SUBMIT_IMPORTAR_CONTACTOS_EXCEL, submitImportarContactosExcel)
}

export function * descargarPlantillaExcelContactosExcel () {
  try {
    const archivoExcel = yield call(getDescargarPlantillaExcelContactosExcel, null)
    let href = 'data:application/csv;base64,' + encodeURIComponent(archivoExcel.xls)
    let name = i18n.t('IMPORTAR_CONTACTOS_EXCEL.EJEMPLO_EXCEL_CONTACTOS') + ".xlsx"
    downloadDocument(href, name)
  } catch (error) {
    console.log(error)
  } finally {
  }
}
export function * watchDescargarPlantillaExcelContactosExcel () {
  yield takeLatest(actionTypes.DESCARGAR_PLANTILLA_EXCEL_CONTACTOS_EXCEL, descargarPlantillaExcelContactosExcel)
}